import React from 'react';
import { motion } from 'framer-motion';
import { Repeat, PenTool, AlertTriangle, Clock, FolderSearch, Briefcase } from 'lucide-react';
const pains = [{
  Icon: Repeat,
  title: 'Repetís siempre las mismas actividades',
  desc: 'Porque no tenés tiempo para preparar cosas nuevas y terminás haciendo siempre lo mismo.'
}, {
  Icon: PenTool,
  title: 'Te cuesta crear proyectos variados',
  desc: 'Combinar técnica, creatividad y progresión pedagógica en cada clase te lleva demasiado tiempo.'
}, {
  Icon: AlertTriangle,
  title: 'Improvisás más de lo que te gustaría',
  desc: 'Llegás al aula pensando qué vas a hacer hoy en lugar de enfocarte en tus alumnos.'
}, {
  Icon: Clock,
  title: 'Perdés horas armando rúbricas y evaluaciones',
  desc: 'Cada trabajo, cada nivel, cada grupo. Desde cero, siempre.'
}, {
  Icon: FolderSearch,
  title: 'No encontrás material organizado',
  desc: 'Tenés links guardados, capturas y hojas sueltas que después no encontrás cuando los necesitás.'
}, {
  Icon: Briefcase,
  title: 'Terminás trabajando fuera de horario',
  desc: 'Noches y fines de semana dedicados a armar clases en lugar de descansar.'
}];
export function PainSection() {
  return <section className="py-24 lg:py-32 bg-paper-main" data-id="element-177">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-179">
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-180">
            ¿Te pasa esto?
          </h2>
          <p className="text-lg text-ink-600 font-normal" data-id="element-181">
            Si sos profe de Arte, esto seguramente te pasa
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-182">
          {pains.map((pain, i) => {
          const Icon = pain.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06,
            duration: 0.8,
            ease: 'easeOut'
          }} className="bg-paper-card rounded-[20px] p-8 shadow-soft border border-paper-border transition-shadow hover:shadow-card" data-id="element-183">
                <div className="w-12 h-12 rounded-full bg-brand-50 text-brand-500 flex items-center justify-center mb-6" data-id="element-184">
                  <Icon className="w-5 h-5" strokeWidth={1.5} data-id="element-185" />
                </div>
                <h3 className="font-serif font-medium text-xl text-ink-800 mb-3 leading-tight" data-id="element-186">
                  {pain.title}
                </h3>
                <p className="text-ink-600 text-sm leading-relaxed font-normal" data-id="element-187">
                  {pain.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}